import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useDefaultVariantSelector = (id: string) => {
  const state = useGetEditOrActual();

  return useMemo(() => state.splitTests[id]?.variants.find(variant => variant.isDefault === true), [
    id,
    state.splitTests,
  ]);
};
